module.exports = __webpack_public_path__ + "img/pwa-install-popup-bg.187017d5.png";